// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '대화제약',
  targetSheetName: '요율표',
  headerRowIndex: 4,
  headerRowCount: 1,
  dataStartRowIndex: 5,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'NO',
    '구분',
    '생산',
    '생동여부',
    '대분류',
    '제품분류',
    '성분명',
    '함량',
    '함량단위',
    '제품명',
    '제품코드',
    '표준코드',
    '보험코드',
    '제품단위',
    '보험약가',
    '수수료',
    '비고',
  ],
});
